module.exports = __webpack_public_path__ + "img/workbg.ea416c16.png";